var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubmission(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_697_777)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.05456 40.0789L11.1924 44.1476V32.7783L2.09644 39.5997L3.05456 40.0789Z",
    fill: "url(#paint0_linear_697_777)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 63.5156C39.6409 63.5156 39.2817 63.4331 38.9519 63.2681L0 43.7924V77.6563C0 78.9506 1.04937 80 2.34375 80H77.6562C78.9506 80 80 78.9506 80 77.6563V43.7924L41.0481 63.2681C40.7183 63.4331 40.3592 63.5156 40 63.5156Z",
    fill: "url(#paint1_linear_697_777)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8076 44.1476L77.9036 39.5997L68.8076 32.7783V44.1476Z",
    fill: "url(#paint2_linear_697_777)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8799 46.4914L40 58.5514L64.1202 46.4912V2.34375C64.1202 1.04937 63.0708 0 61.7764 0H18.2236C16.9293 0 15.8799 1.04937 15.8799 2.34375V46.4914ZM23.8369 16.9892C23.8369 16.1525 24.283 15.3791 25.0075 14.9603C26.3304 14.1953 27.4339 13.0919 28.1988 11.7691C28.6177 11.0445 29.391 10.5984 30.2279 10.5984H49.7724C50.6091 10.5984 51.3827 11.0445 51.8014 11.7691C52.5661 13.0919 53.6696 14.1953 54.9925 14.9603C55.7169 15.3792 56.163 16.1525 56.163 16.9892V23.3522C56.163 29.5964 54.6788 35.2044 51.8707 39.5698C49.1919 43.7342 45.4382 46.6106 40.7136 48.1187C40.4819 48.1928 40.2414 48.2297 40.0008 48.2297C39.7602 48.2297 39.5199 48.1928 39.2882 48.1187C34.5632 46.6106 30.8089 43.7342 28.1299 39.5697C25.3213 35.2039 23.8368 29.5959 23.8368 23.3522V16.9892H23.8369Z",
    fill: "url(#paint3_linear_697_777)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.001 43.4088C43.3268 42.1877 45.9911 40.0459 47.9285 37.0339C50.2491 33.4263 51.4755 28.6952 51.4755 23.3522V18.2574C50.3363 17.4291 49.3324 16.4252 48.5043 15.2859H31.4958C30.6677 16.4252 29.6638 17.4291 28.5244 18.2574V23.3522C28.5244 28.6947 29.7513 33.4258 32.0724 37.0338C34.01 40.0458 36.6747 42.1875 40.001 43.4088ZM33.988 24.9866C35.0504 24.2474 36.5111 24.5092 37.2505 25.5717L38.7455 27.7205L43.1994 24.118C44.2055 23.3042 45.6813 23.4597 46.4957 24.4664C47.3096 25.4727 47.1536 26.9486 46.1472 27.7627L39.7346 32.9494C39.3149 33.2888 38.7938 33.4708 38.2607 33.4708C38.1507 33.4708 38.0404 33.463 37.9304 33.4475C37.2858 33.3556 36.7086 33.0002 36.3368 32.4658L33.4029 28.2491C32.6635 27.1864 32.9255 25.7259 33.988 24.9866Z",
    fill: "url(#paint4_linear_697_777)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_697_777",
    x1: 6.6444,
    y1: 32.7782,
    x2: 6.6444,
    y2: 44.1474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2020FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_697_777",
    x1: 40,
    y1: 43.7923,
    x2: 40,
    y2: 79.9993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2020FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_697_777",
    x1: 73.3556,
    y1: 32.7782,
    x2: 73.3556,
    y2: 44.1474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2020FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_697_777",
    x1: 40,
    y1: -0.00014307,
    x2: 40,
    y2: 58.5502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2020FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_697_777",
    x1: 40,
    y1: 15.2859,
    x2: 40,
    y2: 43.4082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2020FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_697_777"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmission);
export default __webpack_public_path__ + "static/media/submission.ceb55b28407d31a18e20612b614d4b9e.svg";
export { ForwardRef as ReactComponent };